import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  mobileHeading: {
    display: 'none',
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      fontSize: '2.6rem',
      justifyContent: 'center'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem'
    }
  },
  stepButtons: {
    margin: 'auto',
    maxWidth: 560,
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse'
    }
  },
  stepButtonsLeft: {

  },
  stepButtonsRight: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  stepButton: {
    width: 200,
    [theme.breakpoints.down('md')]: {
      marginBottom: 10,
      width: '100%'
    }
  },
  slideOutLoader: {
  },
  slideOutLoaderSpinner: {
    display: 'block',
    margin: 'auto',
  },
  stepContainer: {
    paddingTop:8,
    '& .MuiFormControlLabel-root': {
      marginBottom: 25,
      '& .MuiIconButton-root': {
        marginRight: 0,
        padding: 0
      },
    },
    '& .errorMessage': {
      width: '100%',
      margin: '0 auto 25px',
      maxWidth: 560,
      '& .MuiPaper-root': {
        padding: 20,
        alignItems: 'center',
        position: 'relative',
      },
      '& .MuiCollapse-wrapperInner': {
        margin: 0,

        '& .MuiAlert-icon': {
          margin: '0 6px 0 0',
          padding: '0'
        },
        '& .MuiAlert-message': {
          padding: '2px 10px 0 10px',
          lineHeight: '1.15',
          letterSpacing: '-0.5px',
          '& strong': {
            textTransform: 'uppercase'
          }
        },
        '& .MuiAlert-action': {
          display: 'none'
        }
      },
    },
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column-reverse',
      width: '100%'
    }
  },
  stepSection: {
    padding: 0
  },
  stepForm: {
    maxWidth: 560,
    margin: '0 auto',
    '& .MuiCheckbox-root':{
      padding:0
    }
  },
  stepTracker: {
    marginTop: 60,
    [theme.breakpoints.down('lg')]: {
      marginTop: 30
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 25
    }
  },
  show: {
    transition: "opacity 0.7s linear",
    zIndex: 100,
    border: "1px red solid",
    position: "absolute",
    width: "100%",
    height: "100%"
  },
  hide: {
    opacity: 0
  },
  generateButton: {
    width: 190,
    margin: "0 auto",
    display: "flex",
    justifyContent: "center"
  },
  referralFormParagraph: {
    fontSize: 15,
    fontFamily: "CircularStd",
    color: "#4a4a4a",
    lineHeight: "1.4",
    margin: "0 0 15px",
    letterSpacing: '-0.5px',
    padding: '15px 20px 0 20px',
    '@media(max-width: 768px)': {
      padding: '5px 10px 0 10px',
    },
  },
  checkboxControl: {
    paddingLeft: 10,
    '& .MuiFormControlLabel-label': {
      color: '#4a4a4a',
      fontSize: 16
    },

    '& .MuiSvgIcon-root': {
      fontSize: '2.2rem',
      marginRight: 10
    }
  },
  referralFormContainer: {
    position: 'relative',
    '& h2': {
      fontSize: '26px',
      lineHeight: '34px',
      color: '#4a4a4a',
      textAlign: 'center',
      margin: '0 0 3rem 0',
      fontWeight: '600',
      letterSpacing: '-1px',
    },
  },
  referralFormDetails: {
    margin: "0 auto 35px",
    textAlign: "center",
    color: "#a4a4a4",
    fontSize: 15,
    maxWidth: 460,
    fontFamily: "CircularStd",
    '& p:nth-child(1)': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& span': {
      color: "#4a4a4a",
      display: 'block',
    }
  },
  referralFormItemContainer: {
    marginBottom: 30
  },
});
